<template>
    <v-dialog :id="`dialog_${fullscreen ? 'full' : ''}`"
        transition="dialog-bottom-transition" v-model="show">
        <v-toolbar dark class="edit-item-header">
            <v-btn icon dark @click="show = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-row style="gap: 12px;" class="d-flex flex-row align-center" no-gutters>
                <v-toolbar-title>{{ isExistingEntity ? `Edit ${entityName} Details` : `Add ${entityName}`
                }}</v-toolbar-title>

                <div class="body-1 font-weight-bold">{{ current_entity[entityName]['id'] }}</div>

                <div>
                    <v-icon v-if="current_entity[entityName]['waybillStatus'] == 'Active'" style="font-size: 14px;"
                        color="#FFC107">{{ "mdi-circle" }}</v-icon>
                    <v-icon v-if="current_entity[entityName]['waybillStatus'] == 'In Progress'" style="font-size: 14px;"
                        color="#FFC107">{{ "mdi-circle" }}</v-icon>
                    <v-icon v-if="current_entity[entityName]['waybillStatus'] == 'Completed'" style="font-size: 14px;"
                        color="#4CAF50">{{ "mdi-circle" }}</v-icon>
                    <v-icon v-if="current_entity[entityName]['waybillStatus'] == 'Pending FF'" style="font-size: 14px;"
                        color="#EB5757">{{ "mdi-circle" }}</v-icon>
                    <v-icon v-if="current_entity[entityName]['waybillStatus'] == 'TEST'" style="font-size: 14px;"
                        color="#0B5596">{{ "mdi-circle" }}</v-icon>
                    <v-icon v-if="current_entity[entityName]['waybillStatus'] == undefined" style="font-size: 14px;"
                        color="#0B5596">{{ "mdi-circle" }}</v-icon>
                    <v-icon v-if="current_entity[entityName]['waybillStatus'] == 'Pending Admin'" style="font-size: 14px;"
                        color="#EB5757">{{ "mdi-circle" }}</v-icon>
                    <v-icon v-if="current_entity[entityName]['waybillStatus'] == 'Rejected'" style="font-size: 14px;"
                        color="#EB5757">{{ "mdi-circle" }}</v-icon>
                </div>

                <div class="body-1 font-weight-bold">{{ current_entity[entityName]['waybillStatus'] }}</div>

            </v-row>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-menu v-if="ActualCurrentEntity.id !== undefined && ActualCurrentEntity.id !== 0"
                    v-model="shareButtonTouched" :close-on-content-click="false" transition="scale-transition" offset-y
                    bottom left :nudge-width="300">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-if="shareable !== undefined" dark text @click="share" v-bind="attrs" v-on="on">
                            <v-icon color="primary">{{ "mdi-share-outline" }}</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-col cols="12">
                            <v-text-field outlined :disabled="waybillStatus == 'Completed' || userRoleId == 5
                                || waybillStatus == 'In Progress'
                                " v-if="shareButtonTouched" oulined placeholder="freight-forwarder email"
                                label="Freight Forwarder Email" color="primary" hide-details v-model="email">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" style="text-align:center;">
                            <v-btn :disabled="waybillStatus == 'Completed' || userRoleId == 5
                                || waybillStatus == 'In Progress'
                                " outlined color="primary" :loading="shareLoading" @click="shareByEmail()">
                                Share by email
                            </v-btn>
                        </v-col>
                    </v-card>
                </v-menu>

                <v-btn icon dark textx @click="print">
                    <v-icon color="primary">print</v-icon>
                </v-btn>

                <v-btn icon dark textx @click="save" :loading="postLoading" :disabled="loading || waybillStatus == 'Completed'
                    || waybillStatus == 'In Progress'">
                    <v-icon color="primary">{{ "mdi-content-save-outline" }}</v-icon>
                </v-btn>

            </v-toolbar-items>
        </v-toolbar>
        <v-card style="height: 100%;">
            <v-card-text style="height: 100%;" class="d-flex flex-column pt-6">

                <v-form style="gap: 16px; height: 100%;" class="d-flex flex-row flex-sm-column flex-lg-row flex-xl-row" ref="form"
                    @submit.prevent>

                    <div style="display: flex; flex-direction: column; width:100%;">

                        <v-container style="padding: 0;">
                            <v-col no-gutters>
                                <div class="upper-text body-2">General Information</div>

                                <v-row no-gutters class="mt-4" style="margin-bottom: 24px; width: 100%;">
                                    <v-row no-gutters style="gap: 6px; flex-wrap: nowrap;"> <v-col style="padding: 0;"
                                            cols="12" sm="6">
                                            <v-text-field label="Id" placeholder="Id" prepend-icon="mdi-identifier"
                                                hide-details v-model="current_entity[entityName]['id']"
                                                :value="current_entity[entityName]['id']" disabled outlined></v-text-field>
                                        </v-col>

                                        <v-col style="padding: 0;" cols="12" sm="6">
                                            <v-text-field label="Custom Id" placeholder="Custom Id" hide-details
                                                prepend-icon="mdi-alpha-c-box-outline" outlined
                                                v-model="current_entity[entityName]['identifier']"
                                                :value="current_entity[entityName]['identifier']" :disabled="waybillStatus == 'Completed' || postLoading == true || userRoleId == 5
                                                    || waybillStatus == 'In Progress'"></v-text-field> </v-col>
                                    </v-row>

                                    <v-row class="mt-4" no-gutters style="gap: 6px; flex-wrap: nowrap;"> <v-col
                                            style="padding: 0;" cols="12" sm="6">
                                            <v-menu :disabled="waybillStatus == 'Completed' || userRoleId == 5
                                                || waybillStatus == 'In Progress'
                                                " v-model="fromDateMenu" :close-on-content-click="false"
                                                :nudge-right="40" transition="scale-transition" offset-y max-width="290px"
                                                min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field label="Start date" placeholder="Start date" hide-details
                                                        prepend-icon="mdi-calendar-range-outline" :disabled="waybillStatus == 'Completed' || userRoleId == 5
                                                            || waybillStatus == 'In Progress'
                                                            " readonly outlined
                                                        :value="ActualCurrentEntity['estimatedStartDate']"
                                                        v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker :disabled="waybillStatus == 'Completed'
                                                    || waybillStatus == 'In Progress' ||
                                                    (userRoleId == 5 && waybillStatus != 'Pending FF')
                                                    " locale="en-in"
                                                    v-model="ActualCurrentEntity['estimatedStartDate']"></v-date-picker>
                                            </v-menu>

                                            <!-- <v-date-picker v-model="picker"></v-date-picker> -->
                                        </v-col>

                                        <v-col style="padding: 0;" cols="12" sm="6">

                                            <v-combobox hide-details prepend-icon="mdi-account-outline" :disabled="waybillStatus == 'Completed' || userRoleId == 5
                                                || waybillStatus == 'In Progress'"
                                                v-model="current_entity[entityName]['user']" placeholder="Search for user"
                                                :label="'User'" track-by="userFullName" :items="entities['user']"
                                                :item-text="'userFullName'" :tag-placeholder="`Add this as new user`"
                                                :taggable="true" @tag="addTag" outlined small-chips dense></v-combobox>
                                        </v-col> </v-row>

                                </v-row>
                            </v-col>

                            <v-col>
                                <div class="upper-text body-2">Assignment</div>

                                <v-row no-gutters style="margin-bottom: 24px; margin-top: 16px; width: 100%;">
                                    <v-col style="padding: 0;" cols="12" sm="6">
                                        <v-checkbox hide-details :disabled="waybillStatus == 'Completed' || userRoleId == 5
                                            || waybillStatus == 'In Progress'
                                            " v-model="ActualCurrentEntity['assignToFF']" label="Freight Forwarder"
                                            :value="ActualCurrentEntity['assignToFF']" color="primary">
                                            <template v-slot:label>
                                                <div>
                                                    Assign to Freight Forwarder
                                                </div>
                                            </template>
                                        </v-checkbox> </v-col>

                                    <v-col v-if="ActualCurrentEntity['assignToFF'] == true" style="padding: 0;" cols="12"
                                        sm="6">
                                        <v-combobox hide-details :disabled="waybillStatus == 'Completed' || userRoleId == 5
                                            || waybillStatus == 'In Progress'"
                                            v-model="current_entity[entityName]['freightForwarder']"
                                            placeholder="Search for Freight Forwarder" :label="'Freight Forwarder'"
                                            track-by="userFullName" :items="entities['ff']" :item-text="'userFullName'"
                                            :tag-placeholder="`Add this as new Freight Forwarder`" :taggable="true"
                                            @tag="addTag" prepend-icon="mdi-domain" outlined small-chips dense></v-combobox>
                                    </v-col>

                                    <v-row no-gutters style="gap: 6px; flex-wrap: nowrap; margin-top: 16px;"> <v-col
                                            style="padding: 0;" cols="12" sm="6">
                                            <v-combobox :disabled="waybillStatus == 'Completed'
                                                || waybillStatus == 'In Progress'"
                                                v-model="current_entity[entityName]['drivers']"
                                                placeholder="Search for drivers" :label="'Drivers'" track-by="email"
                                                :multiple="true" :items="entities['driver']"
                                                prepend-icon="mdi-truck-outline" :item-text="'email'"
                                                :tag-placeholder="`Add this as new driver`" :taggable="true" hide-details
                                                @tag="addTag" outlined small-chips dense></v-combobox>
                                        </v-col>

                                        <v-col style="padding: 0;" cols="12" sm="6">
                                            <v-combobox :disabled="waybillStatus == 'Completed'
                                                || waybillStatus == 'In Progress'"
                                                v-model="current_entity[entityName]['trucks']"
                                                placeholder="Search for trucks" :label="'Trucks'" track-by="selectableInfo"
                                                :multiple="true" :items="entities['truck']" :item-text="'selectableInfo'"
                                                :tag-placeholder="`Add this as new truck`" :taggable="true" @tag="addTag"
                                                hide-details prepend-icon="mdi-truck-outline" outlined small-chips
                                                dense></v-combobox>
                                        </v-col> </v-row>

                                </v-row>
                            </v-col>

                            <v-col>
                                <div class="upper-text body-2 mb-2">Qr Code</div>
                                <!--

                            <v-row no-gutters style="margin-bottom: 24px; margin-top: 16px; gap: 6px; width: 100%;">
                                <v-col style="padding: 0;"> -->
                                <!-- <v-text-field label="Clients" placeholder="Clients" prepend-icon="mdi-account"
                                        outlined></v-text-field>  -->
                                <!-- <v-combobox :disabled="waybillStatus == 'Completed' || userRoleId == 5
                                            || waybillStatus == 'In Progress'
                                            "
                            v-model="markers"
                            placeholder="Search for client"
                            label="Clients"
                            track-by="name"
                            :items="entities['deliveryAddress']"
                            :item-text="'name'" 
                            :multiple="true"
                            :taggable="false"
                            :class="generateChipStyle('mediumvioletred')"
                            @tag="addTag"
                            prepend-icon="mdi-account"
                            outlined small-chips dense
                            ></v-combobox>
                                    </v-col>

                                <v-col style="padding: 0;">
                                    <v-text-field label="Geofencing" placeholder="Geofencing"
                                        prepend-icon="mdi-map-marker-path" append-icon="mdi-plus-box" color="red"
                                        outlined></v-text-field> </v-col>

                            </v-row> -->

                                <v-row>

                                    <v-col><v-col style="padding: 0;">
                                            <div style="gap: 10px;" class="d-flex">

                                                <v-icon color="primary">{{ "mdi-qrcode" }}</v-icon>

                                                <div class="div-parent" v-if="showQr">
                                                    <label class="qr-label" color="red">QR Code</label>
                                                    <v-col
                                                        style="padding: 0; display: flex; flex-direction: column; gap: 4px;">
                                                        <div style="width: 100px; height: 100px; object-fit: cover;">
                                                            <img v-if="ActualCurrentEntity['qrCodeMedia'] !== undefined"
                                                                :src="ActualCurrentEntity['qrCodeMedia'].url" height="100"
                                                                width="100" />
                                                        </div>

                                                        <v-btn :disabled="waybillStatus == 'Completed' || userRoleId == 5
                                                            || waybillStatus == 'In Progress'
                                                            " v-if="(isAdmin() || isClient())" raised class="qrCodeButton"
                                                            :loading="qrLoading"
                                                            @click="generateQrCode(0, 'qrCodeMedia', 'qrCodeMediaId')"
                                                            style="align-self: flex-start; display: flex; color: white; text-transform: none;"
                                                            small depressed color="green">Generate</v-btn>
                                                    </v-col>

                                                </div>
                                            </div>
                                        </v-col></v-col>
                                </v-row>

                            </v-col>

                        </v-container>

                    </div>

                    <div class="custom-divider"></div>

                    <div style="display: flex; flex-direction: column; width:100%; gap: 16px;">

                        <google-map-waybill :disabled="waybillStatus == 'Completed'
                            || waybillStatus == 'In Progress' ||
                            (userRoleId == 5 && waybillStatus != 'Pending FF')
                            " @setGeoFence="setGeoFence" :polygons="ActualCurrentEntity.geoRegions"
                            @setStationsList="setStationsList" :stationsList="ActualCurrentEntity.deliveryAddresses"
                            :has_many_stations="true" :stations_selects="StationsSelects" :has_fencing="true"
                            :entity="ActualCurrentEntity"></google-map-waybill>
                        <!-- <div no-gutters style="padding: 0; height: fit-content;">
                        <v-row no-gutters>
                            <v-expansion-panels color="primary" accordion>
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        <v-row style="gap: 12px;" no-gutters>
                                            <div class="d-flex align-items-center"><v-icon color="primary">{{
                                                "mdi-map-outline" }}</v-icon></div>
                                            <div style="gap: 4px;">
                                                <div class="upper-text body-2">Pick points on map</div>
                                                <div class="lower-text-gray body-1">Use map to pick locations by
                                                    dropping pins</div>
                                            </div>
                                        </v-row>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div>
                                            <google-map  :realtime_tracking="true" :simulated="simulatedDriver"/>
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-row>

                    </div>

                    <div class="custom-divider-hor"></div>

                    <div style="gap: 16px; display: flex; flex-direction: column;" no-gutters>

                        <v-row style="justify-content: space-between; padding: 0 12px" no-gutters>

                            <div style="gap: 4px;">
                                <div class="upper-text body-2">Client waybills</div>
                                <div class="lower-text-gray body-1">Drag and drop to re-arrange the waybills</div>
                            </div>

                            <div class="d-flex" style="justify-content: center;"> <v-icon color="primary">{{
                                "mdi-arrow-up-down" }}</v-icon> </div>


                        </v-row>

                        <div class="scroll-cards-parent">

                            <div class="client-waybill-card">

                                <v-row
                                    style="display: flex; flex-direction: row; justify-content: space-between; flex-wrap: nowrap;"
                                    no-gutters>

                                    <div style="width: 100%; display: flex; justify-content: center;"> <v-icon>{{
                                        "mdi-drag-horizontal" }}</v-icon> </div>

                                    <div> <v-icon color="red">{{ "mdi-delete-outline" }}</v-icon> </div>


                                </v-row>

                                <v-col no-gutters>

                                    <v-row no-gutters style="gap: 6px; flex-wrap: nowrap;">
                                        <v-col style="padding: 0;" cols="12" sm="6">
                                            <v-text-field label="Pickup City" placeholder="Pickup City"
                                                outlined></v-text-field>
                                        </v-col>

                                        <v-col style="padding: 0;" cols="12" sm="6">
                                            <v-text-field label="Drop City" placeholder="Drop City" outlined></v-text-field>
                                        </v-col> </v-row>

                                    <v-row no-gutters style="gap: 6px; flex-wrap: nowrap;">

                                        <v-col style="padding: 0;">
                                            <v-text-field label="Estimated Del. Date & Time"
                                                placeholder="Estimated Del. Date & Time" outlined></v-text-field>
                                        </v-col>

                                        <v-col style="padding: 0;">
                                            <v-text-field label="Longitude" placeholder="Longitude" outlined></v-text-field>
                                        </v-col>

                                        <v-col style="padding: 0;">
                                            <v-text-field label="Latitude" placeholder="Latitude" outlined></v-text-field>
                                        </v-col>

                                    </v-row>


                                </v-col>

                            </div>

                        </div>

                    </div> -->


                    </div>

                </v-form>

            </v-card-text>
            <v-card-actions>
                <v-dialog v-if="allowDelete[entityName] && isExistingEntity" v-model="showDeleteConfirm" max-width="290">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text :disabled="loading" @delete="showDeleteConfirm">Delete</v-btn>
                    </template>
                    <v-card>
                        <v-card-title class="headline primary--text" :disabled="waybillStatus == 'Completed'
                            || waybillStatus == 'In Progress' ||
                            (userRoleId == 5 && waybillStatus != 'Pending FF')
                            ">
                            <v-icon color="primary" class="mr-2">error</v-icon>
                            Confirmation
                        </v-card-title>
                        <v-card-text>Are you sure do you want to delete this {{ entity }}?</v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green" text @click="showDeleteConfirm = false">No</v-btn>
                            <v-btn color="red" text @click="deleteThisUser">Yes</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-spacer />
                <span v-if="errorMessage !== ''" class="ml-4 orange--text d-flex align-center">
                    <v-icon color="orange" class="mr-2">error</v-icon>
                    {{ errorMessage }}
                </span>
                <v-spacer />
                <v-btn color="red" text @click="show = false" :disabled="loading || waybillStatus == 'Completed'
                    || waybillStatus == 'In Progress'">Close</v-btn>
                <v-btn color="green" text @click="save" :loading="postLoading" :disabled="loading || waybillStatus == 'Completed'
                    || waybillStatus == 'In Progress'">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import GoogleMapWaybill from '@/components/GoogleMapWaybill'
import MobilePhones from '../views/MobilePhones'
import MobilePhonesStandalone from './MobilePhonesStandalone'
import Multiselect from 'vue-multiselect'
import MediaGallery from './common/MediaGallery'
import Utils from '../mixins/utils'
import ShareByEmail from '../mixins/shareByEmail'

export default {
    data() {
        return {
            userRoleId: localStorage.getItem("UserRoleId"),
            errorMessage: '',
            enableValidation: false,
            showDeleteConfirm: false,
            rules: {
                field: [
                    v => !!v || 'This Field is Required',
                ]
            },
            lang_code: 'en',
            showField: true, //hack to reload the localizable field,
            showAddStandalonePhone: false,
            standalone_phones: [],
            fromDateMenu: false,
            minDate: "1900-01-01",
            search_val: null,
            waybillStatus: localStorage.getItem("SelectedwaybillStatus"),
            selectedMulti: [],
            modal: {
                mediaGalleryShown: {
                    type1: false,
                    type2: false,
                    type3: false,
                    type4: false,
                    type5: false,
                    type6: false,
                    type7: false,
                    type8: false
                },
                qrCodeGalleryShown: false
            },
            showQr: true,
            qrLoading: false,
            postLoading: false,
            shareButtonTouched: false,
            email: "",
            shareLoading: false
        }
    },
    mixins: [Utils, ShareByEmail],
    components: { GoogleMapWaybill, MobilePhones, MobilePhonesStandalone, Multiselect, MediaGallery },
    computed: {
        show: {
            get() {
                return this.isShown;
            },
            set(value) {
                this.standalone_phones = [];
                this.$emit('changed', value);
            }
        },
        isExistingEntity() {
            return this.current_entity[this.entityName] != undefined && this.current_entity[this.entityName].id
        },
        ...mapState('entities', ['loading', 'current_entity', 'entities', 'search', 'selected_search_entity']),
        ...mapState('users', ['loggedIn', 'user']),
        ...mapGetters('entities', ['allowDelete']),
        ActualCurrentEntity: {
            get() {
                return this.current_entity[this.entityName];
            },
            set(value) {
                this.current_entity[this.entityName] = value;
            }
        },
        Languages() {
            return this.entities['language'];
        },
        CurrentLanguage() {
            for (var i = 0; i < this.Languages.length; ++i) {
                var lang = this.Languages[i];
                if (lang.code === this.lang_code) return lang;
            }
            return null;
        },
        CurrentLocalization() {
            if (this.ActualCurrentEntity.localizations === undefined || !Array.isArray(this.ActualCurrentEntity.localizations)) {
                this.ActualCurrentEntity.localizations = [];
            }

            var loc = null;
            var loc_found = false;
            for (var i = 0; i < this.ActualCurrentEntity.localizations.length; ++i) {
                var l = this.ActualCurrentEntity.localizations[i];
                if (l.languageId === this.CurrentLanguage.id) loc = l;
            }
            if (loc === null) {
                loc = { languageId: this.CurrentLanguage.id };
                for (var i = 0; i < this.localizable_fields.length; ++i) {
                    loc[this.localizable_fields[i].value] = "";
                }
                this.current_entity[this.entityName].localizations.push(loc);
            }
            return loc
        },
        CurrentSearchEntity(name) {
            return this.current_entity[name] !== undefined ? this.entities[name].find(x => x.id === this.current_entity[name].userId) : this.selected_search_entity[name];
        },
        StationsSelects() {
            return this.entity_fields.filter(h => h.type === 'multiselect' && h.include_in_station);
        }
    },
    props: ['fullscreen', 'isShown', 'entityName', 'coordinate', 'entity_fields', 'shareable',
        'localizable_fields', 'user_id', 'driver_id'], //the data we're editing might belong to a user or driver
    methods: {
        ...mapActions('entities', ['saveEntity', 'deleteEntity', 'searchEntities']),
        ...mapActions('users', ['isAdmin'], ['isClient']),
        save() {
            if (this.$refs.form.validate()) {
                this.postLoading = true;
                this.errorMessage = '';
                var post_object = { ...this.ActualCurrentEntity };
                console.log(post_object);
                post_object.entity_name = this.entityName;
                if (this.standalone_phones.length > 0) post_object.phones = this.standalone_phones;
                if (this.selected_search_entity['user'] !== undefined) {
                    post_object.userId = this.selected_search_entity['user'].id;
                }
                if (post_object.packages !== undefined) {
                    post_object.packageIds = post_object.packages.map(p => p.id);
                    post_object.packages = null;
                    post_object.packageWayBills = null;
                }
                if (post_object.drivers !== undefined) {
                    post_object.driverIds = post_object.drivers.map(d => d.id);
                    post_object.drivers = null;
                    post_object.driverWayBills = null;
                }
                if (post_object.trucks !== undefined) {
                    post_object.truckIds = post_object.trucks.map(t => t.id);
                    post_object.trucks = null;
                    post_object.truckWayBills = null;
                }
                if (post_object.user !== undefined) {
                    post_object.userId = post_object.user.id;
                    post_object.user = null;
                }
                if (post_object.qrCodeMedia !== undefined) {
                    if (post_object.qrCodeMedia.id !== undefined) {
                        post_object.qrCodeMediaId = post_object.qrCodeMedia.id;
                        post_object.qrCodeMedia = null;
                    }
                }
                if (this.user_id !== undefined) post_object.userId = this.user_id;
                if (this.selected_search_entity['driver'] !== undefined) post_object.driverId = this.selected_search_entity['driver'].id;
                if (this.driver_id !== undefined) post_object.driverId = this.driverId;

                post_object.isActive = true;
                if (this.waybillStatus == "Pending FF" && this.userRoleId == 5) { post_object.assignToFF = true }
                if (this.waybillStatus == "Active" && this.userRoleId == 5) { post_object.assignToFF = false }

                this.saveEntity(post_object).then(response => {
                    this.show = false;
                    this.postLoading = false;
                    this.$emit('entity_posted');
                }).catch(message => {
                    this.errorMessage = message;
                    // this.$swal(message);
                    alert(message);
                    this.postLoading = false;
                })
            }
            this.enableValidation = true;
        },
        deleteEntity() {
            this.showDeleteConfirm = false;
            this.deleteEntity(this.current_entity[this.entityName], this.entityName).then(message => {
                this.show = false;
            }).catch(message => {
                this.errorMessage = message;
            })
        },
        setLanguage(lang) {
            this.showField = false;
            this.lang_code = lang.code;
            setTimeout(h => { this.showField = true }, 100);
        },
        clearSearch(entity) {
            this.search[entity] = [];
        },
        getSearchItems() {
            var items = this.search['user'];
            return items;
        },
        fetchEntriesDebounced() {
            clearTimeout(this._searchTimerId);
            this._searchTimerId = setTimeout(() => {
                this.fetchEntries()
            }, 500) /* 500ms throttle */
        },
        onSelect(option, id) {
            console.log(option, id);
        },
        addTag(newTag) {
            const tag = {
                name: newTag,
                code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            }
            this.options.push(tag);
            this.value.push(tag);
        },
        selectMedia(item) {
            if (item.typeId === 5) {
                this.ActualCurrentEntity.qrCodeMediaId = item.id;
                this.ActualCurrentEntity.qrCodeMedia = item;
                this.ActualCurrentEntity.qrCode = item.name;
            }
            else {
                if (this.ActualCurrentEntity.medias == null) this.ActualCurrentEntity.medias = []
                //find first an item with the same type and replace it
                var mediaIndex = this.ActualCurrentEntity.medias.findIndex(m => m.typeId == item.typeId);
                if (mediaIndex === undefined || mediaIndex === -1) {
                    this.ActualCurrentEntity.medias.push(item);
                }
                else {
                    this.ActualCurrentEntity.medias[mediaIndex] = item;
                }
            }
        },
        removeMedia(item) {
            var index = this.ActualCurrentEntity.medias.indexOf(m => m.id === item.id);
            if (index !== undefined && index !== null) {
                this.ActualCurrentEntity.medias.splice(index, 1);
            }
        },
        getMediaUrl(type) {
            if (this.ActualCurrentEntity.medias !== null && Array.isArray(this.ActualCurrentEntity.medias)) {
                var media = this.ActualCurrentEntity.medias.find(obj => obj.typeId === type);
                return (media !== undefined && media !== null) ? media.url : "";
            }

            return null
        },
        shouldShowMedia(type) {
            if (this.ActualCurrentEntity.medias !== null && Array.isArray(this.ActualCurrentEntity.medias)) {
                var media = this.ActualCurrentEntity.medias.filter(obj => obj.typeId === type);
                return (media !== undefined && media !== null) ? true : false;
            }
        }
        ,
        openMediaGallery(media_type) {
            this.modal.mediaGalleryShown[`type${media_type}`] = true;
        },
        setGeoFence(fence) {
            this.ActualCurrentEntity.geoRegions = fence;
        },
        setStationsList(stationsList) {
            this.ActualCurrentEntity.deliveryAddresses = stationsList;
        },
        generateChipStyle(color) {
            var styleDef = `.${color} .multiselect__tag{background:${color} !important;}`;
            let style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML = styleDef;
            document.head.appendChild(style);
            return color;
        },
        generateQrCode(id, selectorValue, selectorId) {
            this.qrLoading = true;
            axios({
                method: "GET",
                url: `${process.env.VUE_APP_baseURL}media/generateQr?id=${id}`
            }).then(response => {
                this.qrLoading = false;
                var qrMedia = response.data.data.value;
                this.ActualCurrentEntity[selectorValue] = qrMedia;
                this.ActualCurrentEntity[selectorId] = qrMedia.id;
                this.ActualCurrentEntity.qrCode = qrMedia.name;
                this.forceReloadQr();
            }).catch(error => {
                this.qrLoading = false;
                console.log(`ERRORRRRRRRRR ${error}`);
            })
        },
        forceReloadQr() {
            this.showQr = false;
            setTimeout(() => { this.showQr = true }, 150);
        },
        print() {
            // Get HTML to print from element
            window.print();
            // const elements = document.getElementsByClassName('v-dialog__content--active')
            // console.log(elements)
            // if(elements.length > 0) {
            //   const html = elements[0]
            //   const prtHtml = html.innerHTML;

            //   // Get all stylesheets HTML
            //   let stylesHtml = '';
            //   for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            //     stylesHtml += node.outerHTML;
            //   }

            //   // Open the print window
            //   const WinPrint = window.open('', '', 'toolbar=0,scrollbars=0,status=0');

            //   WinPrint.document.write(`<!DOCTYPE html>
            //   <html>
            //     <head>
            //       ${stylesHtml}
            //     </head>
            //     <body>
            //       ${prtHtml}
            //     </body>
            //   </html>`);

            //   WinPrint.document.close();
            //   WinPrint.focus();
            //   WinPrint.print();
            //   WinPrint.close();
            // }
        },
        share() {
            this.shareButtonTouched = !this.shareButtonTouched;
            // const elements = document.getElementsByClassName('v-dialog__content--active')
            // console.log(elements)
            // if(elements.length > 0) {
            //   const html = elements[0]
            //   const prtHtml = html.innerHTML;

            //   // Get all stylesheets HTML
            //   let stylesHtml = '';
            //   for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            //     stylesHtml += node.outerHTML;
            //   }

            //   var emailBody = (`<!DOCTYPE html>
            //   <html>
            //     <head>
            //       ${stylesHtml}
            //     </head>
            //     <body>
            //       ${prtHtml}
            //     </body>
            //   </html>`);

            //   var subject = this.ActualCurrentEntity.identifier;
            //   document.location = "mailto:"+"?subject="+subject+"&body="+emailBody;
            // }
        },
        shareByEmail() {
            this.shareLoading = true;
            var url = `${this.entityName}/shareByEmail`;
            var emailObject = {
                entityId: this.ActualCurrentEntity.id,
                email: this.email
            }
            this.sendEmailEntity(emailObject, url);
        }
    },
    model: {
        prop: 'isShown',
        event: 'changed'
    },
    watch: {
        show(newValue) {
            if (newValue) {
                this.data = Object.assign({}, this.user);
                if (this.$refs.form != undefined)
                    this.$refs.form.resetValidation();
                this.errorMessage = '';
                this.enableValidation = false;
            }
            else {
                this.ActualCurrentEntity = {};
                this.$emit('editItemHidden');
            }
        },
        data: {
            deep: true,
            handler() {
                if (this.enableValidation)
                    this.$refs.form.validate();
            }
        },
        search_val(val) {
            if (this.search['user'] !== undefined && this.search['user'].length > 0) return;
            if (val !== undefined && val !== null) {
                //search for the user and populate the users
                var searchPayLoad = {
                    entity_name: 'user',
                    query: val,
                    fromPage: -1,
                    toPage: -1,
                    count: -1
                }
                this.searchEntities(searchPayLoad);
            }
        },
        search_ff_val(val) {
            if (this.search['ff'] !== undefined && this.search['ff'].length > 0) return;
            if (val !== undefined && val !== null) {
                //search for the user and populate the users
                var searchPayLoad = {
                    entity_name: 'ff',
                    query: val,
                    fromPage: -1,
                    toPage: -1,
                    count: -1
                }
                this.searchEntities(searchPayLoad);
            }
        }
    },
    mounted() {
        if (this.localizable_fields !== undefined && this.localizable_fields.length > 0) {
            //should check if the current entity has a localizations array, else add one
            if (this.ActualCurrentEntity.localizations === undefined || !Array.isArray(this.ActualCurrentEntity.localizations)) {
                this.ActualCurrentEntity.localizations = [];

                //load the array with empty localiable fields for each language
                for (var i = 0; i < this.Languages.length; ++i) {
                    var loc = {};
                    loc.languageId = this.Languages[i].id;
                    for (var j = 0; j < this.localizable_fields.length; ++j) {
                        var field = this.localizable_fields[j];
                        loc[field.value] = "";
                    }
                    this.ActualCurrentEntity.localizations.push(loc);
                }
            }
        }
        localStorage.setItem("SelectedwaybillStatus", "");
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.img-div {
    background-size: contain;
    margin-bottom: 15px;
    height: 100px;
}

.logo-container {
    text-align: center;
}

@media print {
    header {
        display: none;
    }

    .invoiceMedia {
        display: none;
    }

    .qrCodeButton {
        display: none;
    }
}

.div-parent {
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.38);
    border-radius: 4px;
    min-width: 299px;
    max-width: 300px;
}

.qr-label {
    background-color: white;
    margin-top: -21px;
    display: flex;
    max-width: fit-content;
    font-weight: 500;
    font-size: 12px;
    color: #00000050;
}

.custom-divider {
    width: 4px;
    background: linear-gradient(rgba(11, 85, 150, 0) 0%, rgba(11, 85, 150, 1) 50%, rgba(11, 85, 150, 0) 100%);
}

.custom-divider-hor {
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, rgba(11, 85, 150, 0) 0%, rgba(11, 85, 150, 1) 50%, rgba(11, 85, 150, 0) 100%);
}

.upper-text {
    color: #0B5596;
    font-weight: 500;
    text-transform: uppercase;
}

.lower-text-gray {
    color: #808080;
}

.client-waybill-card {
    padding: 8px;
    width: 100%;
    border: 1px solid #0B559630;
    border-radius: 4px;
}

.edit-item-header {
    background: linear-gradient(0.25turn, #0B5596, #EEFCFF);
}
</style>